import { render, staticRenderFns } from "./editSubDepartments.vue?vue&type=template&id=5844ae76&scoped=true"
import script from "./editSubDepartments.vue?vue&type=script&lang=js"
export * from "./editSubDepartments.vue?vue&type=script&lang=js"
import style0 from "./editSubDepartments.vue?vue&type=style&index=0&id=5844ae76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5844ae76",
  null
  
)

export default component.exports